// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"85b29198","170":"49b77d9c","244":"5ebfaa81","664":"a87a971a"}[chunkId] + ".chunk.js";
};